export const firebaseConfig = {
  apiKey: "AIzaSyB839dfkro1Z2NqpJWLzYmJZMvrX7mtZl8",
  authDomain: "info340-group5-project-draft-2.firebaseapp.com",
  databaseURL: "https://info340-group5-project-draft-2-default-rtdb.firebaseio.com",
  projectId: "info340-group5-project-draft-2",
  storageBucket: "info340-group5-project-draft-2.appspot.com",
  messagingSenderId: "166216064135",
  appId: "1:166216064135:web:fd09e9e457f1f954bfac22"
};